// extracted by mini-css-extract-plugin
export default {"tx":"_9423bea082","line":"_99a8ece174"};